import { render, staticRenderFns } from "./PushItem.vue?vue&type=template&id=47fc28d2&scoped=true"
import script from "./PushItem.vue?vue&type=script&lang=js"
export * from "./PushItem.vue?vue&type=script&lang=js"
import style0 from "./PushItem.vue?vue&type=style&index=0&id=47fc28d2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc28d2",
  null
  
)

export default component.exports